export const logBeacon = (stringData: string) => {
  if (navigator) navigator.sendBeacon && navigator.sendBeacon('/api/log', stringData)
}
